export default __webpack_public_path__ + "static/media/3086.f647625e.png";